import { createFileRoute } from '@tanstack/react-router'

import { VehicleManagementPanel } from '@/components/vehicles/vehicle-management-panel'

// The tracking screen is watch-only now (map + list + cameras on one screen),
// so vehicle CRUD lives here again instead of behind a tracking tab.
export const Route = createFileRoute('/_app/_authed/_sidebar/vehicles/')({
    component: VehiclesPage,
})

function VehiclesPage() {
    return (
        <div className="p-4">
            <VehicleManagementPanel />
        </div>
    )
}
